import { render, staticRenderFns } from "./ContentParameters.vue?vue&type=template&id=d39e897e&scoped=true&"
import script from "./ContentParameters.vue?vue&type=script&lang=js&"
export * from "./ContentParameters.vue?vue&type=script&lang=js&"
import style0 from "./ContentParameters.vue?vue&type=style&index=0&id=d39e897e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39e897e",
  null
  
)

export default component.exports